module.exports = __webpack_public_path__ + "img/syLog.34804612.png";